import { EditMaterialForm } from "@/components/Materials/Forms/EditMaterialForm";
import type { Material } from "@/types";
import { Modal } from "@/ui";

interface EditMaterialModalProps {
  material: Material;
  show: boolean;
  onClose: () => void;
}

export const EditMaterialModal = ({
  material,
  show,
  onClose,
}: EditMaterialModalProps) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      title="Edit Material"
      description="Update material details and replace PDF if needed"
    >
      <EditMaterialForm material={material} onClose={onClose} />
    </Modal>
  );
};
